import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisTeamsQueryVariables = Types.Exact<{
  input: Types.HrisTeamsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisTeamsQuery = { __typename?: 'Query', HrisTeams: { __typename?: 'HrisTeams', totalCount: number, objects: Array<{ __typename?: 'HrisTeam', id: number, name: string, createdAt: string, manuallyLinked: boolean, activeHrisEmployeeCount: number, group?: { __typename?: 'Role', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null }> } };

export type DeleteHrisTeamsMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type DeleteHrisTeamsMutation = { __typename?: 'Mutation', deleteHrisTeams: { __typename?: 'GenericMutationResult', success: boolean } };

export type HrisTeamFragment = { __typename?: 'HrisTeam', id: number, name: string, createdAt: string, manuallyLinked: boolean, activeHrisEmployeeCount: number, group?: { __typename?: 'Role', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null };

export const HrisTeamFragmentDoc = gql`
    fragment HrisTeam on HrisTeam {
  id
  name
  createdAt
  group {
    id
    name
  }
  manuallyLinked
  activeHrisEmployeeCount
  hrisIntegration {
    id
    hrisProvider
  }
}
    `;
export const HrisTeamsDocument = gql`
    query HrisTeams($input: HrisTeamsInput!, $pagination: PaginationInput) {
  HrisTeams(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...HrisTeam
    }
  }
}
    ${HrisTeamFragmentDoc}`;

/**
 * __useHrisTeamsQuery__
 *
 * To run a query within a React component, call `useHrisTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisTeamsQuery(baseOptions: Apollo.QueryHookOptions<HrisTeamsQuery, HrisTeamsQueryVariables> & ({ variables: HrisTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisTeamsQuery, HrisTeamsQueryVariables>(HrisTeamsDocument, options);
      }
export function useHrisTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisTeamsQuery, HrisTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisTeamsQuery, HrisTeamsQueryVariables>(HrisTeamsDocument, options);
        }
export type HrisTeamsQueryHookResult = ReturnType<typeof useHrisTeamsQuery>;
export type HrisTeamsLazyQueryHookResult = ReturnType<typeof useHrisTeamsLazyQuery>;
export type HrisTeamsQueryResult = Apollo.QueryResult<HrisTeamsQuery, HrisTeamsQueryVariables>;
export const DeleteHrisTeamsDocument = gql`
    mutation DeleteHrisTeams($ids: [Int!]!) {
  deleteHrisTeams(ids: $ids) {
    success
  }
}
    `;
export type DeleteHrisTeamsMutationFn = Apollo.MutationFunction<DeleteHrisTeamsMutation, DeleteHrisTeamsMutationVariables>;

/**
 * __useDeleteHrisTeamsMutation__
 *
 * To run a mutation, you first call `useDeleteHrisTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHrisTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHrisTeamsMutation, { data, loading, error }] = useDeleteHrisTeamsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteHrisTeamsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHrisTeamsMutation, DeleteHrisTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHrisTeamsMutation, DeleteHrisTeamsMutationVariables>(DeleteHrisTeamsDocument, options);
      }
export type DeleteHrisTeamsMutationHookResult = ReturnType<typeof useDeleteHrisTeamsMutation>;
export type DeleteHrisTeamsMutationResult = Apollo.MutationResult<DeleteHrisTeamsMutation>;
export type DeleteHrisTeamsMutationOptions = Apollo.BaseMutationOptions<DeleteHrisTeamsMutation, DeleteHrisTeamsMutationVariables>;